import { Dropdown, Option } from "@fluentui/react-components";
import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useEditorStyles } from "../Styles/Editor";
import { onFormatDate } from "../Tools/converters";

type PeriodeDropdownProps = {
    setPeriode: (vat: Date) => void;
    currentPeriode: Date|null;
};

type PeriodeItem = {
    key: string;
    label: string;
    periode: Date;
};

export const PeriodeDropdown: React.FC<PeriodeDropdownProps> = ({ setPeriode, currentPeriode }) => {
    const styles = useEditorStyles();
    const { t } = useTranslation();

    // Gen periodes
    const PeriodesItems: PeriodeItem[] = useMemo(() => {
        const today = new Date();
        const lastDayOfMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0);
        const lastDayPrevMonth = new Date(today.getFullYear(), today.getMonth(), 0);
        return [
            {
                key: "Periode0",
                label: (lastDayPrevMonth.getMonth() + 1) + "/" + (lastDayPrevMonth.getFullYear()),
                periode: lastDayPrevMonth
            },
            {
                key: "Periode1",
                label: (lastDayOfMonth.getMonth() + 1) + "/" + (lastDayOfMonth.getFullYear()),
                periode: lastDayOfMonth
            }
        ];
    }, []);

    let PeriodesItemsCurrentSelectionIndex: string | undefined = undefined;
    if (currentPeriode && currentPeriode.getTime() == PeriodesItems[0].periode.getTime()) {
        PeriodesItemsCurrentSelectionIndex = PeriodesItems[0].label;
    }
    else if (currentPeriode && currentPeriode.getTime() == PeriodesItems[1].periode.getTime()) {
        PeriodesItemsCurrentSelectionIndex = PeriodesItems[1].label;
    }
    else {
        PeriodesItemsCurrentSelectionIndex = onFormatDate(currentPeriode ?? undefined);
    }

    return <Dropdown
        className={styles.fluid}
        positioning="below"
        listbox={{
            className: styles.optionContainer,
        }}
        placeholder={t('SelectPeriode')}
        onOptionSelect={(event, data) => {
            const p = PeriodesItems.find(c => c.key === data.optionValue);
            setPeriode(p ? p.periode : PeriodesItems[0].periode);
        }}
        value={PeriodesItemsCurrentSelectionIndex}
        aria-invalid={currentPeriode === null}
    >
        {PeriodesItems.map((i) => < Option key={i.key} value={i.key} >{i.label}</Option >)}
    </Dropdown>;
};